module.exports = __webpack_public_path__ + "img/wave.9e17e2cc.svg";